import { Prop, Component, h, Host, Watch } from '@stencil/core/internal';
import _ds from '../../typescript/dot-stash';
import CssClassList from '../types/css-class-list.interface';

@Component({
  tag: 'ds-text',
  styleUrl: 'text.scss'
})
export class DSText {
	CSSClassList: CssClassList;

  /* @Prop({ reflect: true }) tag: string = "p"; */
	/* Form related */
  @Prop() form: boolean;
	@Prop() label: boolean;
	@Prop() hint: boolean;

	@Prop() italic: boolean;
	@Prop() bold: boolean;
	@Prop() highlight: boolean;
	@Prop() size: string | number;
	@Prop() color: string;
  @Prop() mods: string | string[] = "default";

	@Watch('mods')
  modsChangeHandler( newMods ) {
    this.CSSClassList = _ds.props.toClassList("ds-text", newMods);
  }

	componentWillLoad() {
		this.CSSClassList = _ds.props.toClassList("ds-text", this.mods);
	}
	
	render() {
		return (
			<Host
				class={{
					...this.CSSClassList,
				}}
			>
				<slot />
			</Host>
    );
  }
}